import { Pipe, PipeTransform } from '@angular/core';
import { BasicService } from '../services/basic.service';

@Pipe({
  name: 'bytesPrefix',
})
export class BytesPrefixPipe implements PipeTransform {
  constructor(private basicService: BasicService) {}

  transform(bytes: number): string {
    const byte = this.basicService.translate('byte');
    if (bytes >= 1024 * 1024) {
      return `${Math.round(bytes / (1024 * 1024))}&nbsp;M${byte}`;
    }
    if (bytes >= 1024) {
      return `${Math.round(bytes / 1024)}&nbsp;K${byte}`;
    }
    return `${bytes}&nbsp;${byte}`;
  }
}
